import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {SitesComponent} from './components/sites/sites.component';
import {PageComponent} from './components/page/page.component';
import {SiteComponent} from './components/site/site.component';
import {NotificationsComponent} from './components/notifications/notifications.component';

const appRoutes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: 'sites'},
    {path: 'sites', component: SitesComponent, pathMatch: 'full'},
    {path: 'site/:id', component: SiteComponent},
    {path: 'page/:id', component: PageComponent},
    {path: 'notifications', component: NotificationsComponent},
    {path: ':langCode/sites', component: SitesComponent, pathMatch: 'full'},
    {path: ':langCode/site/:id', component: SiteComponent},
    {path: ':langCode/page/:id', component: PageComponent},
    {path: ':langCode/notifications', component: NotificationsComponent},
    {path: '404', component: PageNotFoundComponent},
    {path: '**', redirectTo: '/404'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/app-routing-module.ts